import { Component, Vue } from 'vue-property-decorator';
import MyAppointments from '@/components/my-appointments';
import AdminList from '@/components/admin-list';

import template from './admin.vue';

@Component({
  mixins: [template],
  components: {
    AdminList
  },
})
export default class Admin extends Vue {
}